import React from 'react';
import { motion } from 'framer-motion';

const universities = [
  "BUET", "Dhaka University", "North South University", "BRAC University", 
  "IUB", "EWU", "AUST", "UIU", "AIUB", "Jahangirnagar University", 
  "Rajshahi University", "SUST", "KUET", "RUET", "CUET", "Jagannath University"
];

const TrustedBy = () => {
  return (
    <div className="py-10 bg-rich-black border-y border-white/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8 text-center">
        <p className="text-sm font-semibold text-medium-gray uppercase tracking-wider">
          Trusted by 500+ Students Across Bangladesh
        </p>
      </div>
      
      <div className="relative flex overflow-hidden">
        <div className="absolute left-0 top-0 bottom-0 w-20 z-10 bg-gradient-to-r from-rich-black to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-20 z-10 bg-gradient-to-l from-rich-black to-transparent pointer-events-none" />
        
        <motion.div
          className="flex gap-16 items-center whitespace-nowrap pl-16"
          animate={{ x: "-50%" }}
          transition={{
            repeat: Infinity,
            ease: "linear",
            duration: 30,
          }}
        >
          {[...universities, ...universities].map((uni, index) => (
            <span 
              key={index} 
              className="text-xl md:text-2xl font-bold text-white/40 hover:text-vibrant-red transition-colors cursor-default"
            >
              {uni}
            </span>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default TrustedBy;
